(ns practitest.frontend.components2.misc-components
  (:require [practitest.frontend.common.dom :as dom]
            [practitest.frontend.common.utils :refer [register-components!]]))

(defn
  ^{:component? true}
  link-button
  "Looks like a link but actually is a button (uses span with m-pseudolink CSS class)"
  [{:keys [disabled? class on-click]} & children]
  (into [:span.m-pseudolink
         {:class (dom/append-class (dom/classes-pairs-v :disabled disabled?)
                                   class)
          :on-click on-click}]
        children))

(register-components!)
